import request from '@/utils/request';

/**
 * 上传责任书
 * @param {string} accidentId 事故ID
 * @param {FormData} data 文件FormData
 */
export function uploadStatement(accidentId, data) {
    return request({
        url: '/accident/upload',
        method: 'post',
        params: { accidentId },
        data
    });
}

export function removeStatement(accidentId) {
    return request({
        url: '/accident/upload/delete',
        method: 'get',
        params: { accidentId }
    });
}
// 上传人伤直赔材料清单
export function uploadWoundedFiles(params, data) {
    return request({
        url: '/accidentWounded/uploadWoundedFiles',
        method: 'post',
        params: { ...params },
        data
    });
}
// 上传拖修车材料清单
export function uploadMaintenanceFiles(params, data) {
    return request({
        url: '/partyMaintenance/uploadMaintenanceFiles',
        method: 'post',
        params: { ...params },
        data
    });
}
// 保险下载相关材料
export function insurancePhoneDownload(accidentId) {
    return request({
        url: '/insurancePhoneDownload',
        method: 'get',
        params: { accidentId },
    });
}
// 转为线下处理
export function offlineProcessing(obj) {
    return request({
        url: '/accident/offlineProcessing',
        method: 'get',
        params: { ...obj }
    });
}

/**
 * 上传调解协议书
 * @param {string} recordId
 * @param {FormData} data 文件FormData
 */
export function uploadAgree(recordId, data) {
  return request({
    url: '/mediator/upload',
    method: 'post',
    params: {recordId},
    data
  });
}
